import React, { useId } from "react";
import { Star } from "lucide-react";

export default function ProductDetailReviews({ summary = {} }) {
  const titleId = useId();
  const count = Math.max(0, Number(summary.count) || 0);
  const rating = count ? Math.max(0, Math.min(5, Number(summary.rating) || 0)) : 0;
  return (
    <section className="productdetail-reviews" aria-labelledby={titleId}>
      <h2 id={titleId}>Customer Reviews</h2>
      <div className="productdetail-reviews__stars" role="img" aria-label={`${rating.toFixed(1)} out of 5 stars`}>
        {[1, 2, 3, 4, 5].map((star) => <Star key={star} size={19} fill={star <= Math.round(rating) ? "currentColor" : "none"} aria-hidden="true" />)}
      </div>
      <p className="productdetail-reviews__score">{rating.toFixed(1)} / 5.0</p>
      <p className="productdetail-reviews__count">{count} customer {count === 1 ? "rating" : "ratings"}</p>
      <div className="productdetail-reviews__distribution">
        {[5, 4, 3, 2, 1].map((star) => {
          const percent = count ? Math.min(100, Math.max(0, Math.round((Number(summary.distribution?.[star]) || 0) / count * 100))) : 0;
          return <div className="productdetail-reviews__row" key={star}>
            <span>{star} {star === 1 ? "star" : "stars"}</span>
            <div className="productdetail-reviews__bar" role="meter" aria-label={`${star} star ratings`} aria-valuemin={0} aria-valuemax={100} aria-valuenow={percent}><span style={{ width: `${percent}%` }} /></div>
            <span>{percent}%</span>
          </div>;
        })}
      </div>
      {count === 0 && <p className="productdetail-reviews__empty">No Customer Reviews</p>}
    </section>
  );
}
